import * as yup from 'yup';
import { VideoModal } from '@web/components';
import { schema as muxVideoSchema } from './mux_video';

export const component = VideoModal;

export const schema = yup
  .object({
    video: muxVideoSchema,
    videoOrientation: yup.string(),
    component: yup.string(),
  })
  .required()
  .transform(value => ({
    video: value?.video?.[0] ?? value.video,
    videoOrientation: value?.video_orientation,
    component: value.component,
  }));
